import React, { useEffect, useState } from 'react';
import './AgentPointer.css';

/**
 * Visual pointer overlay — animates movement and click/type actions in the computer preview.
 */
export default function AgentPointer({ action, isVisible, onComplete }) {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isClicking, setIsClicking] = useState(false);
  const [isTyping, setIsTyping] = useState(false);
  const [typedText, setTypedText] = useState('');

  useEffect(() => {
    if (!action || !isVisible) return;

    // Handle moveCursor action
    if (action.type === 'moveCursor') {
      const { x, y } = action;
      setPosition({ x, y });
      if (onComplete) {
        setTimeout(() => onComplete(), 300);
      }
    }

    // Handle click action
    if (action.type === 'click') {
      const { x, y } = action.position || { x: 0, y: 0 };
      setPosition({ x, y });
      setIsClicking(true);
      setTimeout(() => {
        setIsClicking(false);
        if (onComplete) onComplete();
      }, 200);
    }

    // Handle type action
    if (action.type === 'type') {
      const { x, y, text, speed = 50 } = action;
      setPosition({ x, y });
      setIsTyping(true);
      setTypedText('');

      let currentIndex = 0;
      const typeInterval = setInterval(() => {
        if (currentIndex < text.length) {
          setTypedText(text.substring(0, currentIndex + 1));
          currentIndex++;
        } else {
          clearInterval(typeInterval);
          setIsTyping(false);
          setTimeout(() => {
            setTypedText('');
            if (onComplete) onComplete();
          }, 500);
        }
      }, speed);

      return () => clearInterval(typeInterval);
    }
  }, [action, isVisible, onComplete]);

  if (!isVisible) return null;

  return (
    <>
      <div
        className={`agent-pointer ${isClicking ? 'clicking' : ''} ${isTyping ? 'typing' : ''}`}
        style={{
          left: `${position.x}px`,
          top: `${position.y}px`,
        }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M5 3l4 4-3 3 5 5-2 2 5 5-1 1 4-4-5-5 2-2-5-5 3-3-4-4z" />
        </svg>
      </div>
      {isTyping && typedText && (
        <div
          className="typing-indicator"
          style={{
            left: `${position.x + 20}px`,
            top: `${position.y}px`,
          }}
        >
          {typedText}
        </div>
      )}
    </>
  );
}

